import { Conversation as APIConversation } from '@sdk/messages/types/apiTypes';
import { PersonaCollection } from '@sdk/personaCollection/types/PersonaCollection';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { getMessageUser } from './getMessageUser';

export function getConversationInterlocutor(
  conversation: APIConversation,
  personaCollection: PersonaCollection,
  currentUser: AuthUserType
) {
  const { deleted, private: isPrivate, personas } = conversation;
  const interlocutorFromApi = personas.find(({ id }) => currentUser.id !== id);
  if (deleted || !isPrivate || !interlocutorFromApi) {
    return null;
  }

  return getMessageUser(interlocutorFromApi, personaCollection, currentUser);
}
